/**
 * Get the user language of the browser settings, or an environment variable (LANG, LANGUAGE)
 * @returns [String]
 */
const getLocaleFromBrowser = () => {
  let locale = ''

  if (global.chrome && global.chrome.runtime && typeof global.chrome.runtime.getManifest === 'function') {
    locale = global.chrome.runtime.getManifest()
    if (locale && locale.current_locale) {
      return locale.current_locale
    }
  }

  locale =
    global.navigator && ((global.navigator.languages && global.navigator.languages[0]) || global.navigator.language || global.navigator.userLanguage)

  if (!locale && global.navigator && global.navigator.userAgent) {
    locale = global.navigator.userAgent.match(/;.(\w+-\w+)/i)
    if (locale) return locale[1]
  }

  if (!locale) {
    locale = (global.clientInformation || Object.create(null)).language
  }

  if (!locale) {
    if (global.Intl && typeof global.Intl.DateTimeFormat === 'function') {
      locale = global.Intl.DateTimeFormat().resolvedOptions && global.Intl.DateTimeFormat().resolvedOptions().locale
    }
    if (!locale && ['LANG', 'LANGUAGE'].some(Object.hasOwnProperty, process.env)) {
      return (process.env.LANG || process.env.LANGUAGE || String()).replace(/[.:].*/, '').replace('_', '-')
    }
  }

  return locale
}

/**
 * Transforms the user's language by the correct one used in the language configuration, if it is not passed as a parameter, it tries to obtain it from browser or environment.
 * @param [String] locale
 *
 * @return [String]
 */
const getParseLocale = (locale) => {
  const newLocale = locale || getLocaleFromStorage() || getLocaleFromBrowser(locale)

  if (typeof newLocale !== 'string') return newLocale || 'en'

  return newLocale.split('-')[0].toLowerCase()
}

const getLocaleFromStorage = () => {
  return localStorage.getItem('current_locale') || ''
}

const updateLocaleInStorage = (locale) => {
  localStorage.setItem('current_locale', locale || '')
}


export {
  getLocaleFromBrowser,
  getParseLocale,
  updateLocaleInStorage
}
